import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.37312 0.958909C1.9826 0.568385 1.34943 0.568385 0.958909 0.958909C0.568385 1.34943 0.568385 1.9826 0.958909 2.37312L6.58607 8.00028L0.958909 13.6274C0.568385 14.018 0.568385 14.6511 0.958909 15.0417C1.34943 15.4322 1.9826 15.4322 2.37312 15.0417L8.00028 9.41449L13.6274 15.0416C14.018 15.4322 14.6511 15.4322 15.0416 15.0416C15.4322 14.6511 15.4322 14.018 15.0416 13.6274L9.41449 8.00028L15.0416 2.37314C15.4322 1.98261 15.4322 1.34945 15.0416 0.958923C14.6511 0.568399 14.018 0.568399 13.6274 0.958923L8.00028 6.58607L2.37312 0.958909Z",
    fill: "#939393"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]




export default {
  __name: 'CloseButton',
  emits: ['close'],
  setup(__props, { emit }) {



const handleClick = () => {
    emit('close');
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: handleClick,
    type: "button",
    class: "Button--no-style calendar-modal-close-icon"
  }, _hoisted_2))
}
}

}